/** 摄像头设备类型统一：平台标准码 CAMERA；IP_CAMERA / FARM_CAMERA 等仅查询兼容 */

export const TYPE_CAMERA = 'CAMERA';

export const CAMERA_TYPE_ALIASES = Object.freeze([
  'CAMERA',
  'IP_CAMERA',
  'FARM_CAMERA',
  'FC5_CAMERA'
]);

const CAMERA_TYPE_SET = new Set(CAMERA_TYPE_ALIASES);

export function normalizeCameraType(deviceType) {
  const t = String(deviceType || '').trim().toUpperCase();
  if (!t) return deviceType;
  if (isCameraType(t)) return TYPE_CAMERA;
  return t;
}

export function isCameraType(deviceType) {
  const t = String(deviceType || '').trim().toUpperCase();
  if (!t) return false;
  if (CAMERA_TYPE_SET.has(t)) return true;
  return t.includes('CAMERA');
}

/** 列表筛选：筛 CAMERA 时兼容旧码 */
export function matchesCameraTypeFilter(actualType, filterType) {
  const want = String(filterType || '').trim().toUpperCase();
  if (!want) return true;
  if (want === TYPE_CAMERA) {
    return isCameraType(actualType);
  }
  return String(actualType || '').trim().toUpperCase() === want;
}
